import React, { useEffect, useState } from 'react'
import "../scss/claimDetail.scss"
import { format } from 'date-fns';
import { filterLetters, getFileExtension, getFromDecreaptLocalStorage, mockMobileNumber, titleCase,CONSTANTS } from '../utilFunctions';
import LoadingPage from '../reusableComponents/loader/loadingPage';
import Accordion from 'react-bootstrap/Accordion';
import { toast } from 'react-toastify';
import TextTruncate from '../utilsComponent/textTruncate';
import { REACT_APP_KSHEMA_POC2, REACT_APP_VAM_ENDPOINT, REACT_APP_VAM_CONTEXT_INGESTION, REACT_APP_VAM_CONTEXT_DOCUMENT } from '../urls';
import { Button, Modal } from "react-bootstrap";
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import DocumentShow from '../utilsComponent/documentShow';
import PdfViewBase from './PdfViewBase';
import { axiosRequest, axiosWithoutToken } from '../service';
import { getCalamityNames, getClaimDocuments, getPortalNames } from './apiHelper';
import { GOVT_PRODUCT,GOVT_PRODUCT_IDS, PAGE_NAME_KEYS } from '../consts';

const ClaimIntiDetail = (props) => {
    const { claimDetailCookie, policyDetailCookie, getClaimDetails, policySearch, productNames } = props;
    const [majorperil, setMajorperil] = useState('')
    const [minorPeril, setMinorPeril] = useState('')
    const [showDoc, setShowpdoc] = useState('');
    const [loading, setLoading] = useState(false)
    const [showDocumentsModel, setShowDocumentsModel] = useState(false)
    const [showPolicyDocumentsModel, setShowPolicyDocumentsModel] = useState(false)
    const [policyImages, setPolicyImages] = useState(false);
    const [customerImages, setCustomerImages] = useState([])
    const [current, setCurrent] = useState(0);
    const [fileType, setFileType] = useState(null);
    const [calamityType, setCalamityType] = useState("")
    const [portalType, setPortalType] = useState("")
    const [openAddPolicyModel, setOpenAddPolicyModel] = useState(false)
    const [selectedProduct, setSelectedProduct] = useState({})
    const [selectedPolicyNumber, setSelectedPolicyNumber] = useState("")
    const roleDataCookie = getFromDecreaptLocalStorage("roleData")
    const [document, setDocument] = useState([])
    const [claimCount, setClaimCount] = useState(0)
    const [showNotify,setShowNotify]=useState(false)
    const [disableProductSelection, setDisableProductSelection] = useState(false);
    const [isLoadingDocs, setIsLoadingDocs] = useState(false);
    const [isDocsEnabled, setIsDocsEnabled] = useState(true);
    const options = [
        { channel_name: "CMS", channel_id: 1 },
        { channel_name: "iAgri", channel_id: 2 },
        { channel_name: "TollFreeNumber", channel_id: 3 },
        { channel_name: "FrontDesk", channel_id: 4 },
        { channel_name: "PublicLink", channel_id: 5 },
        { channel_name: "SocialMedia", channel_id: 6 },
        { channel_name: "QRCode", channel_id: 7 },
        { channel_name: "WhatsApp", channel_id: 8 },
        { channel_name: "SMS", channel_id: 9 },
        { channel_name: "Email", channel_id: 10 },
        { channel_name: "GovernmentPortal", channel_id: 11 },
        { channel_name: "NOC", channel_id: 12 },
        { channel_name: "Kiosk", channel_id: 13 },
    ]
    const majorPerils = [
        ['Cyclone'],
        ['Flood'],
        ['Hailstorm'],
        ['Inundation']
    ];

    const minorPerils = [
        ['Aircraft Damage'],
        ['Earthquake'],
        ['Fire'],
        ['Landslide'],
        ['Animal Attack']
    ];
    const navigate = useNavigate()

    useEffect(() => {
        claimDetailCookie?.policy?.policyNumber && getFarmerClaimCount()   
    }, [claimDetailCookie?.policy?.policyNumber])

    const getDocuments = async ()=>{
        const data = await getClaimDocuments(claimDetailCookie.claimNo);
        if(data?.data){
            setDocument(data.data)
        }
    }
    useEffect(() => {
       getDocuments();
    }, [])
    useEffect(()=>{
        if(claimCount && claimCount > 1) setShowNotify(true)
    },[claimCount])

    const getFarmerClaimCount = () => {
        axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_INGESTION}/basicSearch`, {
            searchType: 1,
            productID: claimDetailCookie.productID,
            searchValue: claimDetailCookie?.policy?.policyNumber
        }).then(data => {        
            setClaimCount(data.data.length)          
        }).catch(error => {
            console.log(error)
        })
    }


    const getCropAge = () => {
      // Show the crop age if and only if the intimation is at policy period and intimation should be after sowing date
      if (
        claimDetailCookie?.dateAndTimeOfLoss &&
        policyDetailCookie?.sowing_date &&
        policyDetailCookie.policy_end_Date &&
        new Date(claimDetailCookie?.dateAndTimeOfLoss) -
          new Date(policyDetailCookie?.sowing_date) >
          0 &&
        new Date(policyDetailCookie.policy_end_Date).setHours(23, 59, 59, 999) -
          new Date(claimDetailCookie?.dateAndTimeOfLoss) >
          0
      ) {
        const differenceInTime = Math.abs(
          new Date(claimDetailCookie?.dateAndTimeOfLoss) -
            new Date(policyDetailCookie?.sowing_date)
        );
        const differenceInDays = Math.round(
          differenceInTime / (1000 * 60 * 60 * 24)
        );
        return differenceInDays + " Days";
      } else {
        return "--";
      }
    };

    const showMajorperil = (response) => {
        setLoading(true)
        const responseArray = response?.split(", ");
        if (responseArray) {
            for (const peril of responseArray) {
                if (majorPerils.some(list => list.includes(peril))) {
                    setMajorperil(peril)
                } else if (minorPerils.some(list => list.includes(peril))) {
                    setMinorPeril(peril);
                }
                setLoading(false)
            }
        } else {
            setLoading(false)
        }
    }

    const getCalamityMaster = () => {
        getCalamityNames({setCalamityType,claimDetailCookie})
        getPortalNames({setPortalType, claimDetailCookie});
    }
    useEffect(() => {
        getCalamityMaster()
        showMajorperil(claimDetailCookie?.policy?.perilNames)
    }, [claimDetailCookie?.policy?.perilNames])

    useEffect(()=>{
        const selectedProductOption = productNames.find(product => product.value === claimDetailCookie.productID);
        if (selectedProductOption) {
            setSelectedProduct(selectedProductOption)
            setDisableProductSelection(true)
        }
    }, [openAddPolicyModel])

    const getChannelName = () => {
        const selectedOption = options.find(
            (option) => option.channel_id === claimDetailCookie?.channelID
        );
        return selectedOption ? selectedOption.channel_name : 'Unknown';
    };
    const getCustomerDOcuments = async () => {
        setIsLoadingDocs(true);
        setIsDocsEnabled(false);
        try {
            const res = await axiosWithoutToken().get(
                `${REACT_APP_KSHEMA_POC2}/farmer-doc/${policyDetailCookie?.farmer_id}`
            );

            const { frontImage, backImage, photo } = res?.data?.Response || {};

            if (!frontImage && !backImage && !photo) {
                toast.error("There is no farmer documents for this claim");
            } else {
                const images = [
                    frontImage?.replace('file:', ''),
                    backImage?.replace('file:', ''),
                    photo?.replace('file:', '')
                ].filter(Boolean);

                setCustomerImages(images);
                setShowDocumentsModel(true);
            }
        } catch (error) {
            console.error("Error loading customer documents:", error);
        } finally {
            setIsLoadingDocs(false);
            setIsDocsEnabled(true); // Always re-enable the button
        }
    };

    const getPolicyDOcuments = (policy_document) => {
        setFileType(getFileExtension(policy_document))
        const doc_id = policy_document.replace(".pdf", "")
        axiosWithoutToken().get(`${REACT_APP_KSHEMA_POC2}/policy-doc/${doc_id}`)
            .then(res => {
                const images = [res.data.Response.imageUrl.replace('file:', '')]
                setPolicyImages([...images])
                if (images.length === 0) {
                    toast.error("There is no policy documents for this claim")
                }
                else {
                    setShowPolicyDocumentsModel(true)
                }
            }).catch(error => {
                console.log(error)
            })
    }
    const addPolicyNumber = async() => {   
        if (!selectedProduct.value) {
            toast.error("Please Select Product Name.")
            return
        }
        if (!selectedPolicyNumber) {
            toast.error("Please Enter Policy Number.")
            return
        }
        if(policyDetailCookie?.policyNumber){
            if(selectedPolicyNumber !== policyDetailCookie?.policy_number){
                toast.error("Please enter valid policy number")
                return
            }
        }else{
            try{
                const response = await axiosWithoutToken().post(`${REACT_APP_KSHEMA_POC2}/search`, {
                    searchType: GOVT_PRODUCT_IDS?.includes(claimDetailCookie.productID) ? CONSTANTS.SEARCH_TYPE_POLICY_NUMBER : CONSTANTS.SEARCH_TYPE_TRANSACTION,
                    product: selectedProduct.label,
                    searchValue: GOVT_PRODUCT_IDS?.includes(claimDetailCookie.productID) ? selectedPolicyNumber : claimDetailCookie?.policy?.tranId
                })
                if(response?.data[0]?.policy_number!==selectedPolicyNumber) {
                    toast.error("Please enter valid policy number")
                    return
                }
            }catch(e) {

            }
        }      

        setLoading(true)
        axiosWithoutToken().post(`${REACT_APP_KSHEMA_POC2}/search`, {
            searchType: CONSTANTS.SEARCH_TYPE_POLICY_NUMBER,
            product: selectedProduct.label,
            searchValue: selectedPolicyNumber
        }).then(data => {
            if (data.data && data.data !== "No Data Present" && data.data.length > 0) {
                axiosRequest().put(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_INGESTION}/updatePolicy`, { createdBy: roleDataCookie.userID,claimNo: claimDetailCookie.claimNo, policyNumber: selectedPolicyNumber, productId: String(selectedProduct.value) }).then(data => {
                    if (data.data === "Please enter valid policy number.") {
                        toast.error(data.data)
                    } else if (data?.data?.message == 'Farmer Name and/or Mobile number and/or Product type mismatch between Claim data and Application Data') {
                        toast.error(data.data.message)
                        setSelectedPolicyNumber("");
                        setSelectedProduct({})
                        setOpenAddPolicyModel(false)
                        setLoading(false)
                    } else {
                        policySearch(selectedPolicyNumber, "", claimDetailCookie.claimNo, selectedProduct.label, selectedProduct.value)
                        getClaimDetails(claimDetailCookie.claimNo)
                        toast.success("Policy has been Tagged Successfully")
                        setSelectedPolicyNumber("");
                        setSelectedProduct({})
                        setOpenAddPolicyModel(false)
                    }
                }).catch(error => {
                    console.log(error)
                    setLoading(false)
                    toast.error("Something Went Wrong.")
                })
            } else {
                setSelectedPolicyNumber("");
                setSelectedProduct({})
                setOpenAddPolicyModel(false)
                setLoading(false)
                toast.error("Policy Number Not Available.")
            }
        }).catch(error => {
            toast.error("Unable to Fetch Policy Details.")
            console.log(error)
            setLoading(false)
        })
    }
    const nextSlide = () => {
        setCurrent(current === customerImages.length - 1 ? 0 : current + 1);
    };

    const prevSlide = () => {
        setCurrent(current === 0 ? customerImages.length - 1 : current - 1);
    };

    return (
        <>
            {loading ? (<LoadingPage></LoadingPage>) : (
                <div className="inner-box2Field  mt-3" style={{ backgroundColor: "transparent" }}>       
                    <div> 
                        <Accordion defaultActiveKey={["0", "1"]} alwaysOpen>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>Claim Details</Accordion.Header>
                                <Accordion.Body>
                                    {
                                        ((claimDetailCookie.productID === 3 || claimDetailCookie.productID === 4) && claimDetailCookie.channelID === 11) ? (

                                            <div className="detailsIndividual">
                                                <div className="row">
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual">Policy Number</p>
                                                        {
                                                            claimDetailCookie?.policy?.policyNumber ? (
                                                                <div className="align1_dataIndividual">{claimDetailCookie?.policy?.policyNumber}</div>
                                                            ) : (
                                                                (roleDataCookie?.roleName == "CALL_CENTRE" || roleDataCookie?.roleName == "CLAIMS_HANDLER" || roleDataCookie?.roleName == "Admin") && <div onClick={() => setOpenAddPolicyModel(true)} className="align1_data_plus"><span id="plus">+</span><span>Tag Policy</span></div>
                                                            )
                                                        }
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_xsIndividual">Peril Type</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.perilName}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_mdIndividual">Crop Name</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.riskName}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lgIndividual 5align_smIndividual">Date &amp; Time of Peril Occurrence</p>
                                                        <div className="align1_dataIndividual"> {claimDetailCookie?.dateAndTimeOfLoss && format(new Date(claimDetailCookie?.dateAndTimeOfLoss.split(".")[0]), 'dd-MM-yyyy, hh:mm a')}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Alternate Contact Number</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.alternateMobileNumber ? claimDetailCookie?.alternateMobileNumber : "--"}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Brief Description of Loss</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.descriptionofLoss ? <TextTruncate text={claimDetailCookie?.descriptionofLoss} length={15} /> : "--"}</div>
                                                    </div>

                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Source Name</p>
                                                        <div className="align1_dataIndividual">{portalType?.name}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Source Ticket Number</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.bulkTicketNumber}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Claim Ingestion Type</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.ingestionType == 1 ? "Individual" : "Area Based"}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Calamity Type</p>
                                                        <div className="align1_dataIndividual">{calamityType?.name}</div>
                                                    </div>
                                                    {/* <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                    <p class="align1Individual align_lowerboxIndividual">Product Name</p>
                                            
                                                    <div class="align1_dataIndividual">{claimDetailCookie?.productType}</div>
                                                </div> */}
                                                    {/* <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                    <p class="align1Individual align_lowerboxIndividual">Year</p>
                                                  
                                                    <div class="align1_dataIndividual">{"--"}</div>
                                                </div> */}
                                                    {/* <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                    <p class="align1Individual align_lowerboxIndividual">Season</p>
                                                   
                                                    <div class="align1_dataIndividual">{"--"}</div>
                                                </div> */}
                                                    {/* <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                    <p class="align1Individual align_lowerboxIndividual">GOVT - Policy Number</p>
                                                    <div class="align1_dataIndividual">{claimDetailCookie?.policy?.policyNumber}</div>
                                                </div> */}
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Farmer Name</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.farmerName}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Father Name</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.fatherName ? claimDetailCookie?.fatherName : "--"}</div>
                                                    </div>
                                                    {/* <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                    <p class="align1Individual align_lowerboxIndividual">Crop Stage Type</p> */}
                                                    {/* <div class="align1_dataIndividual">{claimDetailCookie?.descriptionofLoss ? claimDetailCookie?.descriptionofLoss : "--"}</div> */}
                                                    {/* <div class="align1_dataIndividual">{"--"}</div>
                                                </div> */}
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Crop Status At Incidence</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.cropStatusAtIncident}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Survey Number</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.landSurveyNumber}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Land Sub division Number</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.landSubDivisionNumber}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Intimation Date</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.claimOpenDate && format(new Date(claimDetailCookie?.claimOpenDate.replace(" ", "T").split(".")[0]), 'dd-MM-yyyy, hh:mm a')}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Harvest Date</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.harvestDate ? claimDetailCookie?.harvestDate : "--"}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">State</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.state ? claimDetailCookie?.state : "--"}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">District</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.district}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Tehsil</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.tehsil}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Block</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.block}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Village</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.village}</div>
                                                    </div>
                                                    {/* <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                    <p class="align1Individual align_lowerboxIndividual">Gram Panchayath</p>
                                                    <div class="align1_dataIndividual">{"--"}</div>
                                                </div> */}
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Area Affected</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.affectedArea}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Date of Sowing</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.dateOfSowing ? format(new Date(claimDetailCookie?.dateOfSowing), 'dd-MM-yyyy') : "--"}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Address</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.address ? claimDetailCookie.address : "--"}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Average Yield</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.avgYield}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Threshold Yield</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.thresholdYield}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">iuCode</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.iuCode}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">iuName</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.iuName}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">iuLevelName</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.iuLevelName}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Affected Area %</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.affectedAreaPercentage} </div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Loss %</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.lossPercentage}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Attachment Type</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.attachmentType ? titleCase(claimDetailCookie?.attachmentType) : "--"}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">CMS Entered Date &amp; Time</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.createdDate && format(new Date(claimDetailCookie?.createdDate.split(".")[0]), 'dd-MM-yyyy, hh:mm a')}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Source</p>
                                                        <div className="align1_dataIndividual">{getChannelName()}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Attached Files</p>
                                                        {filterLetters(document, false).length ? (
                                                            <div className="deleteIndividual">
                                                                <span
                                                                    className="hoverIndividual"
                                                                    onClick={() => { navigate(`/dashboard/${PAGE_NAME_KEYS.CLAIM_PROCESSING}/${PAGE_NAME_KEYS.DOCUMENTS}`) }}
                                                                >
                                                                    <TextTruncate text={'Click to view files'} length={23} />
                                                                </span>
                                                            </div>
                                                        ) : <div className="align1_dataIndividual">--</div>}
                                                    </div>
                                                    {
                                                        claimDetailCookie?.policy?.policyNumber && (
                                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                                <p className="align1Individual align_lowerboxIndividual align_farmerIndividual">Total Claims Raised by Farmer </p>
                                                                <div className="align1_dataIndividual">{claimCount}</div>
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                                <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Claim Remarks</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.claimRemarks}</div>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="detailsIndividual">
                                                <div className="row">
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual">Policy Number</p>
                                                        {
                                                            (claimDetailCookie?.policy?.policyNumber && claimDetailCookie?.policy?.policyNumber !== claimDetailCookie?.policy?.tranId)? (
                                                                <div className="align1_dataIndividual">{claimDetailCookie?.policy?.policyNumber}</div>
                                                            ) : (
                                                                (roleDataCookie?.roleName == "CALL_CENTRE" || roleDataCookie?.roleName == "CLAIMS_HANDLER" || roleDataCookie?.roleName == "CLAIMS_MANAGER" || roleDataCookie?.roleName == "Admin") && <div onClick={() => setOpenAddPolicyModel(true)} className="align1_data_plus"><span id="plus">+</span><span>Tag Policy</span></div>
                                                            )
                                                        }
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_xsIndividual">Peril Type</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.perilName}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_mdIndividual">Crop Name</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.riskName}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lgIndividual 5align_smIndividual">Date &amp; Time of Peril Occurrence</p>
                                                        <div className="align1_dataIndividual"> {claimDetailCookie?.dateAndTimeOfLoss && format(new Date(claimDetailCookie?.dateAndTimeOfLoss.split(".")[0]), 'dd-MM-yyyy, hh:mm a')}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Alternate Contact Number</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.alternateMobileNumber ? claimDetailCookie?.alternateMobileNumber : "--"}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Brief Description of Loss</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.descriptionofLoss ? <TextTruncate text={claimDetailCookie?.descriptionofLoss} length={15} /> : "--"}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Attachment Type</p>
                                                        <div className="align1_dataIndividual">{titleCase(claimDetailCookie?.attachmentType)}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">CMS Entered Date &amp; Time</p>
                                                        <div className="align1_dataIndividual">{claimDetailCookie?.createdDate && format(new Date(claimDetailCookie?.createdDate.split(".")[0]), 'dd-MM-yyyy, hh:mm a')}</div>
                                                    </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Source</p>
                                                        <div className="align1_dataIndividual">{getChannelName()}</div>
                                                    </div>
                                                        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                            <p className="align1Individual align_lowerboxIndividual">Transaction ID</p>
                                                            <div className="align1_dataIndividual">{claimDetailCookie?.policy?.tranId ? claimDetailCookie?.policy?.tranId : policyDetailCookie?.tran_id ? policyDetailCookie?.tran_id : "--"}</div>
                                                        </div>
                                                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                        <p className="align1Individual align_lowerboxIndividual">Attached Files</p>
                                                        {filterLetters(document, false).length ? (
                                                            <div className="deleteIndividual">
                                                                <span
                                                                    className="hoverIndividual"
                                                                    onClick={()=>{navigate(`/dashboard/${PAGE_NAME_KEYS.CLAIM_PROCESSING}/${PAGE_NAME_KEYS.DOCUMENTS}`)}}
                                                                >
                                                                    <TextTruncate text={'Click to view files'} length={23} />
                                                                </span>
                                                            </div>
                                                            ): <div className="align1_dataIndividual">--</div>}
                                                    </div>

                                                    {
                                                        claimDetailCookie?.policy?.policyNumber && (
                                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                                <p className="align1Individual align_lowerboxIndividual align_farmerIndividual">Total Claims Raised by Farmer </p>
                                                                <div className="align1_dataIndividual">{claimCount}</div>
                                                            </div>
                                                        )
                                                    }
                                                    {claimDetailCookie?.perilName === "Animal Attack" &&(
                                                        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                            <p className="align1Individual align_lowerboxIndividual">Animal Name</p>
                                                            <div className="align1_dataIndividual">{claimDetailCookie?.perilAnimalName ? claimDetailCookie?.perilAnimalName : "--"}</div>
                                                        </div>)}
                                                        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                            <p className="align1Individual align_lowerboxIndividual">Claim Intimated By</p>
                                                            <div className="align1_dataIndividual">{claimDetailCookie?.claimIntimatedBy ? claimDetailCookie?.claimIntimatedBy : "--"}</div>
                                                        </div>
                                                        {claimDetailCookie?.claimIntimatedRelationship && (
                                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                                <p className="align1Individual align_lowerboxIndividual">Relationship with Policyholder</p>
                                                                <div className="align1_dataIndividual">{claimDetailCookie?.claimIntimatedRelationship ? claimDetailCookie?.claimIntimatedRelationship : "--"}</div>
                                                            </div>)}
                                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                                <p className="align1Individual align_lowerboxIndividual">Letters</p>
                                                                <div className="align1_dataIndividual">
                                                                    {filterLetters(document, true).length ? (
                                                                        <div className="letters">
                                                                            <DocumentShow document={filterLetters(document, true)} heading={'Letters'} />
                                                                        </div>
                                                                    ) : "--"}
                                                                </div>
                                                            </div>
                                                            <div className="remarks-block">
                                                                <p className="align1Individual align_lowerboxIndividual claim-remarks-title"> Claim Remarks</p>
                                                                <div className="align1_dataIndividual">{claimDetailCookie?.claimRemarks}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                        )
                                    }
                                </Accordion.Body>
                            </Accordion.Item>
                            {(claimDetailCookie?.policy?.policyNumber) && (<Accordion.Item eventKey="1">
                                <Accordion.Header>Policy Details</Accordion.Header>
                                <Accordion.Body>
                                    <div className="detailsIndividual">
                                        <div className="row">
                                            <div className="align5_dataIndividual">Insured Details</div>
                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual">FID <span className="asteriskIndividual"></span></p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.farmer_id}</div>
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual align_xsIndividual">Farmer Name</p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.customer_name}</div>
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual align_mdIndividual">Mobile Number</p>
                                                <div className="align1_dataIndividual">{mockMobileNumber(policyDetailCookie?.customer_mobile_number)}</div>
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual align_lgIndividual">Proposer Name</p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.proposer_name ? policyDetailCookie?.proposer_name : "--"}</div>
                                            </div>
                                            {/* <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                    <p class="align1Individual align_lowerboxIndividual">Year</p>
                                                  
                                                    <div class="align1_dataIndividual">{"--"}</div>
                                             </div> */}
                                            {/* <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                            <p class="align1Individual align_lowerboxIndividual">Document ID <span class="asteriskIndividual"></span></p>
                            <div class="align1_dataIndividual">{policyDetailCookie?.document_number}</div>
                        </div> */}
                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual align_lowerboxIndividual">CKYC Number</p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.customer_ckyc_number ? mockMobileNumber(policyDetailCookie?.customer_ckyc_number) : "--"}</div>
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual align_lowerboxIndividual">Pin Code</p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.policy_pincode}</div>
                                            </div>
                                            {/* <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p class="align1Individual align_lowerboxIndividual">Location</p>
                                                <div class="align1_dataIndividual">{policyDetailCookie?.customer_location}</div>
                                            </div> */}
                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual align_lowerboxIndividual">State</p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.policy_state_name}</div>
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual align_lowerboxIndividual">District</p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.policy_district_name}</div>
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual align_lowerboxIndividual">Tehsil/Block/Mandal</p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.policy_mandal_name}</div>
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual align_lowerboxIndividual">Village</p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.policy_village_name}</div>
                                            </div>

                                            {/* <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p class="align2Individual align_lowerboxIndividual">Address <span class="asteriskIndividual"></span></p>
                                                <div class="align2_dataIndividual">{<TextTruncate text={policyDetailCookie?.customer_address} length={12} />}</div>
                                            </div> */}

                                            <div className="align6_dataIndividual">Subject Matter Details</div>

                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual">Product Name <span className="asteriskIndividual"></span></p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.product_name}</div>
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual align_xsIndividual">Policy Sum Insured</p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.sum_insured ? policyDetailCookie?.sum_insured.toFixed(2) : "--"}</div>
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual align_mdIndividual">Premium Excl GST</p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.premium ? policyDetailCookie?.premium.toFixed(2) : "--"}</div>
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual align_lgIndividual">GST@18%</p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.gst_charges ? policyDetailCookie?.gst_charges.toFixed(2) : "--"}</div>
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual align_lowerboxIndividual">Premium Incl GST <span className="asterisk"></span></p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.premium_paid ? policyDetailCookie?.premium_paid.toFixed(2) : "--"}</div>
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual align_lowerboxIndividual">Policy Start Date</p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.policy_start_date ? format(new Date(policyDetailCookie?.policy_start_date.split(".")[0]), 'dd-MM-yyyy') : "--"}</div>
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual align_lowerboxIndividual">Policy End Date</p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.policy_end_Date ? format(new Date(policyDetailCookie?.policy_end_Date.split(".")[0]), 'dd-MM-yyyy') : "--"}</div>
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual align_lowerboxIndividual">Season</p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.season_name}</div>
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual align_lowerboxIndividual">Crop Name <span className="asteriskIndividual"></span></p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.crop_name}</div>
                                            </div>

                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual align_lowerboxIndividual">Crop Variety</p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.crop_variety}</div>
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual align_lowerboxIndividual">Survey Number</p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.survey_number}</div>
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual align_lowerboxIndividual">Policy Number</p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.policy_number}</div>
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual align_lowerboxIndividual">Endorsement Number <span className="asteriskIndividual"></span></p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.endorsement_number ? policyDetailCookie?.endorsement_number : "--"}</div>
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual align_lowerboxIndividual">Perils</p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.perils ? <TextTruncate text={policyDetailCookie.perils.join(",")} length={22} /> : "--"}</div>
                                            </div>

                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual align_lowerboxIndividual">Policy Purchases Date</p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.policy_issuance_date ? format(new Date(policyDetailCookie?.policy_issuance_date.split(".")[0]), 'dd-MM-yyyy') : "--"}</div>
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual align_lowerboxIndividual">Policy Status</p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.policy_status ? titleCase(policyDetailCookie?.policy_status) : "--"}</div>
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual align_lowerboxIndividual">Date Of Sowing</p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.sowing_date ? format(new Date(policyDetailCookie?.sowing_date), 'dd-MM-yyyy') : "--"}</div>
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual align_lowerboxIndividual">Insured Area{claimDetailCookie?.productID !== 3 && claimDetailCookie?.productID !== 4?"(Acre)":"(ha)"}</p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.cultivated_area ? policyDetailCookie?.cultivated_area : "--"}</div>
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual align_lowerboxIndividual">Duration</p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.policy_duration ? policyDetailCookie.policy_duration + " " + "Days" : "--"}</div>
                                                </div>
                                                <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual align_lowerboxIndividual">Crop Age</p>
                                                <div className="align1_dataIndividual">{getCropAge()}</div>
                                            </div>
                                            {/* <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                            <p class="align1Individual align_lowerboxIndividual">Minor Peril</p>
                            <div class="align1_dataIndividual">{minorPeril}</div>
                        </div> */}
                                            {/* <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                <p className="align2Individual align_lowerboxIndividual">Documents <span className="asteriskIndividual"></span></p>
                                                <div className="align_4_dataIndividual deleteIndividual">
                                                    <span className="hoverIndividual" onClick={() => getPolicyDOcuments(policyDetailCookie?.policy_document)}>{policyDetailCookie?.policy_document}</span>
                                                </div>
                                            </div> */}
                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-6">
                                                <p className="align2Individual align_lowerboxIndividual">
                                                    Policy Documents <span className="asteriskIndividual"></span>
                                                </p>

                                                {/* <div
                                                    className={`align_4_dataIndividual deleteIndividual ${!isDocsEnabled ? 'disabled-docs' : ''}`}
                                                    style={{
                                                        pointerEvents: isDocsEnabled ? 'auto' : 'none',
                                                        opacity: isDocsEnabled ? 1 : 0.5
                                                    }}
                                                >
                                                    <div className="spinner-container">
                                                        <span
                                                            className="align1_dataCalc pointer text-primary single-line-link"
                                                            onClick={getCustomerDOcuments}
                                                        >
                                                            Click to open
                                                        </span>

                                                        {isLoadingDocs && (
                                                            <div className="small-spinner ms-2" role="status">
                                                                <span className="visually-hidden">Loading...</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div> */}
                                                <div className="align_4_dataIndividual deleteIndividual">
                                                    <span
                                                        className="hoverIndividual"
                                                        onClick={() => { navigate(`/dashboard/${PAGE_NAME_KEYS.CLAIM_PROCESSING}/${PAGE_NAME_KEYS.DOCUMENTS}`,{state: {activeTab: "policyDocuments"}}) }}
                                                    >
                                                        <TextTruncate text={'Click to view files'} length={23} />
                                                    </span>
                                                </div>
                                            </div>

                                             <div className="align6_dataIndividual mt-5">Bank Details</div>

                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual">Bank Name <span className="asteriskIndividual"></span></p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.bank_name || '--'}</div>
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual">Account No<span className="asteriskIndividual"></span></p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.account_number || "--"}</div>
                                            </div>
                                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                                <p className="align1Individual">IFSC Code</p>
                                                <div className="align1_dataIndividual">{policyDetailCookie?.ifsc_code ||  "--"}</div>
                                            </div>
                                        </div>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                            )}
                        </Accordion>
                    </div>
                    {
                        showNotify && (
                            <Modal size="sm" centered={true} show={showNotify} >
                                    <Modal.Header>
                                        <Modal.Title >Reminder
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <p>Please note that this policy has multiple claims.</p>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={()=>setShowNotify(false)}> Got it</Button>
                                    </Modal.Footer>
                            </Modal>
                        )
                    }
                    {
                        showPolicyDocumentsModel && (
                            <Modal
                                {...props}
                                size="lg"
                                aria-labelledby="contained-modal-title-vcenter"
                                centered
                                show={showPolicyDocumentsModel}
                                onHide={() => setShowPolicyDocumentsModel(false)}
                                backdrop="static"
                            >
                                <Modal.Header>
                                    <Modal.Title id="contained-modal-title-vcenter">
                                        Policy Documents
                                    </Modal.Title>
                                    <span onClick={() => { setShowPolicyDocumentsModel(false) }} className="custom-close" style={{ marginTop: "-50px", marginRight: "-10px" }}>&times;</span>
                                </Modal.Header>
                                <Modal.Body style={{overflow:"scroll"}}>
                                    <section className='slider'>
                                        {policyImages.length > 1 && <i className="fa fa-angle-left gis-image-scrollerGIS" style={{ marginLeft: "110px" }} onClick={prevSlide}></i>}
                                        {policyImages && policyImages.map((image, index) => {
                                            return (
                                                <div
                                                    className={index === current ? 'slide active' : 'slide'}
                                                    key={index}
                                                >
                                                    {index === current && (                                                       
                                                            fileType === "pdf" ? (
                                                                <PdfViewBase base64={image} key={index}/>
                                                            ) : (
                                                                <img src={image} style={{ marginLeft: "180px" }} height={"360px"} width={"400px"} alt='' className='image' />
                                                            )                      
                                                         
                                                        //  <PdfViewer docUrl={image}/>
                                                        // 
                                                    )}
                                                </div>
                                            );
                                        })}
                                        {
                                            policyImages.length > 1 && <i className="fa fa-angle-right gis-image-scrollerGIS_right" onClick={nextSlide}></i>
                                        }
                                        
                                    </section>
                                </Modal.Body>
                            </Modal>
                        )
                    }
                    {
                        showDocumentsModel && (
                            <Modal
                                {...props}
                                size="lg"
                                aria-labelledby="contained-modal-title-vcenter"
                                centered
                                show={showDocumentsModel}
                                onHide={() => setShowDocumentsModel(false)}
                                backdrop="static"
                            >
                                <Modal.Header>
                                    <Modal.Title id="contained-modal-title-vcenter">
                                        Customer Documents
                                    </Modal.Title>
                                    <span onClick={() => { setShowDocumentsModel(false) }} className="custom-close" style={{ marginTop: "-50px", marginRight: "-10px" }}>&times;</span>
                                </Modal.Header>
                                <Modal.Body>
                                    <section className='slider'>
                                        <i className="fa fa-angle-left gis-image-scrollerGIS" style={{ marginLeft: "110px" }} onClick={prevSlide}></i>
                                        {customerImages && customerImages.map((image, index) => {
                                            return (
                                                <div
                                                    className={index === current ? 'slide active' : 'slide'}
                                                    key={index}
                                                >
                                                    {index === current && (
                                                        <img src={'data:image/png;base64,' + image} style={{ marginLeft: "180px" }} height={"360px"} width={"400px"} alt='' className='image' />
                                                    )}
                                                </div>
                                            );
                                        })}
                                        <i className="fa fa-angle-right gis-image-scrollerGIS_right" onClick={nextSlide}></i>
                                    </section>
                                </Modal.Body>
                            </Modal>
                        )
                    }
                    {
                        openAddPolicyModel && (
                            <div id="overlay12Field" style={{ height: "280px" }}>
                                {
                                    loading ? (
                                        <LoadingPage/>
                                    ) : (
                                        <>
                                            <div className="overlay_textCalc text-right me-3"><span type="button" onClick={() => setOpenAddPolicyModel(false)} className="close" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></span></div>
                                            <div style={{ paddingLeft: "20px" }}>
                                                <div className="col-xl-11 col-lg-11 col-md-11 col-sm-11">
                                                    <label for="exampleInputPassword1">Product Name</label><span className="text-danger">*</span>
                                                    <Select id="exampleInputPassword1" options={productNames}
                                                        classNamePrefix="bg-gray" placeholder="Select Kshema Product"
                                                        value={selectedProduct.label ? { label: selectedProduct.label } : { label: "Select Kshema Product", value: "Select Kshema Product" }}
                                                        onChange={(data) => {
                                                            setSelectedProduct(data)
                                                        }}
                                                        isDisabled = {disableProductSelection}
                                                    />
            
                                                </div>
                                                <div className="col-xl-11 col-lg-11 col-md-11 col-sm-11 mt-3">
                                                    <label for="exampleInputPassword1">Policy Number</label><span className="text-danger">*</span>
                                                    <input
                                                        className="bg-gray addPolicymodal" placeholder="Enter Policy Number"
                                                        value={selectedPolicyNumber}
                                                        maxLength={50}
                                                        onChange={(e) => {
                                                            setSelectedPolicyNumber(e.target.value)
                                                        }}
                                                    />
            
                                                </div>
                                            </div>
                                            <button className="backField" onClick={() => { setOpenAddPolicyModel(false); setSelectedPolicyNumber(""); setSelectedProduct({}) }}>Cancel</button>
                                            <button className="submit-1Field" onClick={() => addPolicyNumber()}>Submit</button>                              
                                        </>
                                    )
                                }
                            </div>
                        )
                    }
                </div>)}
        </>
    )
}

export default ClaimIntiDetail

